export const ACCOUNT_LOGIN_FAILURE = 'ACCOUNT_LOGIN_FAILURE'
export const ACCOUNT_LOGIN_SUCCESS = 'ACCOUNT_LOGIN_SUCCESS'
export const COGNITO_LOGIN_USER = 'COGNITO_LOGIN_USER'
export const SET_USER = 'SET_USER'
export const COGNITO_LOGIN_ERROR = 'COGNITO_LOGIN_ERROR'
export const COGNITO_LOGIN_ATTEMPT = 'COGNITO_LOGIN_ATTEMPT'
export const ACCOUNT_LOGIN_RESET = 'ACCOUNT_LOGIN_RESET'
export const ACCOUNT_LOGOUT = 'ACCOUNT_LOGOUT'
export const LOAD_COMPANY = 'LOAD_COMPANY'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS'
export const ACCOUNT_LOGIN_LOAD = 'ACCOUNT_LOGIN_LOAD'
export const ACCOUNT_FORGOT_PASSWORD_ATTEMPT = 'ACCOUNT_FORGOT_PASSWORD_ATTEMPT'
export const ACCOUNT_FORGOT_PASSWORD_SUCCESS = 'ACCOUNT_FORGOT_PASSWORD_SUCCESS'
export const ACCOUNT_FORGOT_PASSWORD_FAILURE = 'ACCOUNT_FORGOT_PASSWORD_FAILURE'
export const ACCOUNT_SET_PREFERENCES = 'ACCOUNT_SET_PREFERENCES'
export const ACCOUNT_GET_PREFERENCES = 'ACCOUNT_GET_PREFERENCES'
export const ACCOUNT_PUT_PREFERENCES = 'ACCOUNT_PUT_PREFERENCES'
export const ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES = 'ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES'
export const ACCOUNT_SET_PREFERENCES_SHOW_LOADING = 'ACCOUNT_SET_PREFERENCES_SHOW_LOADING'
export const ACCOUNT_SET_PREFERENCES_HIDE_LOADING = 'ACCOUNT_SET_PREFERENCES_HIDE_LOADING'

export default {
  ACCOUNT_LOGIN_FAILURE,
  ACCOUNT_LOGIN_SUCCESS,
  COGNITO_LOGIN_USER,
  SET_USER,
  COGNITO_LOGIN_ERROR,
  COGNITO_LOGIN_ATTEMPT,
  ACCOUNT_LOGIN_RESET,
  ACCOUNT_LOGOUT,
  LOAD_COMPANY,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  ACCOUNT_LOGIN_LOAD,
  ACCOUNT_FORGOT_PASSWORD_ATTEMPT,
  ACCOUNT_FORGOT_PASSWORD_SUCCESS,
  ACCOUNT_FORGOT_PASSWORD_FAILURE,
  ACCOUNT_SET_PREFERENCES,
  ACCOUNT_GET_PREFERENCES,
  ACCOUNT_PUT_PREFERENCES,
  ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES,
  ACCOUNT_SET_PREFERENCES_SHOW_LOADING,
  ACCOUNT_SET_PREFERENCES_HIDE_LOADING
}
